import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './guard/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./auth/features/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/features/full/full.component').then(m => m.FullComponent),
    children: [
      { path: '', loadChildren: () => import('./modulos/dashboard/dashboard.routes') },
    ],
  },
  { path: '**', redirectTo: 'overview' },
];
